import React from "react";
import { Toaster } from "react-hot-toast";

function ToastLayout({ children }) {
  return (
    <div>
      <Toaster
        gutter={24}
        toastOptions={{
          className: "",
          style: {
            border: "1px solid #713200",
            padding: "16px",
            color: "#713200",
            maxWidth: "60%",
          },
        }}
      />
      {children}
    </div>
  );
}

export default ToastLayout;
